import {Modal} from "../Modal";
import React from "react";
import {useModalContext} from "../../contexts/ModalContext/context";
import {Button} from "../../UI/Button";
import {Box} from "../../UI/Box";

export interface DeleteLevelModalProps {
    onConfirm: VoidFunction;
    levelType: string;
    levelName: string;
}

export const DeleteLevelModal: React.FC<DeleteLevelModalProps> = ({onConfirm, levelType, levelName}) => {
    const {setIsOpen} = useModalContext();

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Modal
            title={"Confirm " + levelType + " Deletion"}
            onClose={handleClose}
            actions={
                <>
                    <Button onClick={handleClose} appearance="primary">
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} appearance="danger">
                        Delete {levelType}
                    </Button>
                </>
            }
        >
            <Box px={3} py={2}>
                You are about to delete the {levelType} “{levelName}”. This cannot be undone.
            </Box>
        </Modal>
    );
};